const setGraphData_newsell = payload => {
  return {
    type: "setGraphData_newsell",
    payload
  };
};
export default setGraphData_newsell;
